import type { BrainConversationActivity } from '../../src/shared/wireContract';

/** How many of the reader's own conversations hold an unread agent reply. One count for every surface
 *  that shows it (the browser tab title and the sidebar's conversation entry), so they never disagree;
 *  `undefined` while the listing has not loaded. */
export function unreadConversationCount(sessions: readonly { activity?: Pick<BrainConversationActivity, 'unread'> | null }[] | undefined): number | undefined {
  return sessions?.filter(session => session.activity?.unread === true).length;
}
